import React, { Component } from 'react';
import FaIcon from '../../components/global/fa-icon/fa-icon';


export default class LoadingView extends Component {
  render() {
    return (
      <div className="loading-view fade-in">
        <div className="loading-content">
          <div className="loading-message">
            Loading...
          </div>
          <div className="loading-spinner">
            <FaIcon icon="fa-spinner fa-pulse fa-3x" />
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      </div>
    );
  }
}
